import { storeToRefs } from "pinia";

import { useUserSettingsStore } from "@/follaw-fr/stores/user-settings";
import { useUserStore } from "@/follaw-fr/stores/user";
import type { Ref } from "vue";
import { RouteName } from "../RouteNames";

/**
 * Un onboarding terminé ne se rejoue pas : chaque passage recréait une veille, son récapitulatif
 * et « Ma première alerte », donc des mails en double.
 * `user-settings` n'est chargé qu'une fois par session : la fin de l'onboarding ne le met pas à jour.
 * L'état frais est `onboardingCompleted` du store `user`, rafraîchi à la fin de chaque étape.
 */
const onboardingDejaTermine = async () => {
  const { user } = storeToRefs(useUserSettingsStore()) as {
    user: Ref<any>;
  };
  if (!user.value) {
    const { getUserSettings } = useUserSettingsStore();
    await getUserSettings();
  }
  const { onboardingCompleted } = storeToRefs(useUserStore());
  if (user.value?.onboarding_completed || onboardingCompleted.value) {
    return { name: RouteName.Home };
  }
};

export const onboardingRoutes = {
  name: RouteName.OnboardingRoot,
  path: "/onboarding",
  component: () => import("@follaw-fr/views/onboarding/OnboardingView.vue"),
  redirect: { name: RouteName.OnboardingSetupDashboard }, // Redirect to the first step of onboarding
  children: [
    {
      path: "dashboard",
      name: RouteName.OnboardingSetupDashboard,
      component: () =>
        import("@follaw-fr/views/onboarding/OnboardingDashboardView.vue"),
      beforeEnter: onboardingDejaTermine,
    },
    {
      path: "alerts",
      name: RouteName.OnboardingSetupAlerts,
      component: () =>
        import("@follaw-fr/views/onboarding/OnboardingAlertsView.vue"),
      beforeEnter: onboardingDejaTermine,
    },
    {
      // Écran « Terminé » : on y arrive justement une fois l'onboarding fini, donc sans la garde ci-dessus.
      path: "done",
      name: RouteName.OnboardingDone,
      component: () =>
        import("@follaw-fr/views/onboarding/OnboardingDoneView.vue"),
    },
  ],
};
